/**
 * Note: PostMessage is still being used for tagging on 3-party Restaurant sites
 */
import { checkIfWidget } from '../utils';
import { sanitizeObject } from '../utils/sanitizeObject';

const PostMessage = () => {
  const serviceName = 'PostMessage';

  const checkTargetWindow = () => {
    if (window.parent !== window && (window.parent?.postMessage)) {
      return window.parent;
    }
    if (window.opener && window.opener?.postMessage) {
      return window.opener;
    }

    return null;
  };

  const event = (name, props = {}) => {
    if (!checkIfWidget()) return false;
    const targetWindow = checkTargetWindow();
    targetWindow?.postMessage(
      sanitizeObject({
        type: 'ResyWidgetEvent',
        name,
        properties: props,
      }), '*'
    );

    return true;
  };

  const page = (location, referrer, metadata) => {
    if (!checkIfWidget()) return false;
    const targetWindow = checkTargetWindow();
    targetWindow?.postMessage(sanitizeObject({
      type: 'ResyWidgetEvent',
      name: metadata?.pageName,
      properties: {
        category: 'PageView',
        path: location.path(),
        url: location.url(),
        referrer,
      },
    }), '*');

    return true;
  };

  const purchase = (orderId, data) => {
    if (!checkIfWidget()) return false;
    const targetWindow = checkTargetWindow();
    targetWindow?.postMessage(
      sanitizeObject({
        ...data,
        type: 'ResyWidgetEvent',
        name: 'Reservation placed',
        properties: {
          category: 'Reservation',
          orderId,
        },
      }), '*'
    );

    return true;
  };

  return {
    event,
    page,
    purchase,
    serviceName,
  };
};

export default PostMessage();
